module.exports = __webpack_public_path__ + "img/USERS_GROUP.b0f4ad17.svg";